'use client';

import { useEffect, useState } from 'react';
import { useCopyToClipboard } from '@uidotdev/usehooks';
import { IconCopy, IconCopySuccess } from '@/features/icons';
import { cn } from '@/utils/cn';
interface Props {
  textCopy: string;
  className?: string;
  copyButtonClassName?: string;
  hasUnderline?: boolean;
  onClick?: () => void;
}
export default function CopyBox({
  textCopy,
  className,
  copyButtonClassName,
  hasUnderline,
  onClick
}: Props) {
  const [, copyToClipboard] = useCopyToClipboard();
  const [showTick, setShowTick] = useState(false);
  const handleCopyUrl = () => {
    onClick && onClick();
    copyToClipboard(textCopy);
    setShowTick(true);
  };
  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (showTick) {
      timer = setTimeout(() => {
        setShowTick(false);
      }, 1500);
    }
    return () => clearTimeout(timer);
  }, [showTick]);
  return <div className={cn('left-to-right mx-auto flex w-fit items-center gap-2 rounded-lg border border-border-pink bg-primary-shade-50 p-2 lg:p-3', className)} data-sentry-component="CopyBox" data-sentry-source-file="index.tsx">
            {showTick ? <IconCopySuccess className='h-6 w-6 shrink-0 text-alert-success-dark' /> : <IconCopy className={cn('h-6 w-6 shrink-0 cursor-pointer', copyButtonClassName)} onClick={handleCopyUrl} />}
            <div className={cn('text-body-14 font-medium lg:text-body-16', {
      'underline underline-offset-4': hasUnderline
    })}>
                {textCopy}
            </div>
        </div>;
}